module.exports = __webpack_public_path__ + "img/slide12.d814f457.png";